import {
  Dialog,
  Box,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import { useState } from "react";

export default function FullscreenImageViewer({
  open,
  image,
  onClose,
}) {
  const [zoom, setZoom] = useState(1);

  const handleClose = () => {
    setZoom(1);
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullScreen
      sx={{
        "& .MuiDialog-paper": {
          bgcolor: "black",
        },
      }}
    >
      {/* TOP BAR */}
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          height: 56,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 1,
          zIndex: 10,
          background:
            "linear-gradient(to bottom, rgba(0,0,0,0.7), transparent)",
        }}
      >
       
        <Box>
          <IconButton
            onClick={() => setZoom((z) => Math.min(z + 0.25, 3))}
            sx={{ color: "white" }}
          >
            <ZoomInIcon />
          </IconButton>
          <IconButton
            onClick={() => setZoom((z) => Math.max(z - 0.25, 1))}
            sx={{ color: "white" }}
          >
            <ZoomOutIcon />
          </IconButton>
        </Box>
         <IconButton onClick={handleClose} sx={{ color: "white" }}>
          <CloseIcon />
        </IconButton>

      </Box>

      {/* IMAGE */}
      <Box
        sx={{
          width: "100vw",
          height: "100dvh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
        }}
      >
        <Box
          component="img"
          src={image}
          alt=""
          sx={{
            maxWidth: "100%",
            maxHeight: "100%",
            objectFit: "contain",
            transform: `scale(${zoom})`,
            transition: "transform 0.25s ease",
          }}
        />
      </Box>
    </Dialog>
  );
}
